import BaseApi from "./BaseApi"

export async function getPlayerData(playerReqDto) {
    return await BaseApi.post("/api/public/v1/compute/getPlayerData", playerReqDto);
  }